import { MessageAPI } from "@/api/MessageAPI";

export const messageModule = {
    state: () => ({
        sortByType: '',
        sortByDate: '',
        messageId: '',
        messages: []
    }),
    getters: {
        sortedMessages(state){
            let messages = state.messages
            if(state.sortByType !== ''){
                state.sortByType ? messages.sort((mess1, mess2) => mess1.message_object.type?.localeCompare(mess2.message_object.type)) : messages.sort((mess1, mess2) => mess2.message_object.type?.localeCompare(mess1.message_object.type))
            }
            if(state.sortByDate !== ''){
                state.sortByDate ? messages.sort((mess1, mess2) => new Date(mess1.message_object.created_at) > new Date(mess2.message_object.created_at)) : messages.sort((mess1, mess2) => new Date(mess1.message_object.created_at) < new Date(mess2.message_object.created_at))
            }
            
            return messages
        },
        getMessage(state){
            return state.messages.find(message => +message.id === +state.messageId)
        },
        existUnreadMessage(state){
            return state.messages?.some(message => +message.status === 1)
        },
        newMessage(state){
            return state.messages?.find(message => +message.status === 1) || state.messages[0]
        }
    },
    mutations: {
        setMessages(state, messages) {
            state.messages = messages.results
        },
        sortMessages(state, type) {
            (type == 'type') ? (state.sortByType = !state.sortByType) : (state.sortByDate = !state.sortByDate)
        },
        setMessageId(state, id){
            state.messageId = id
        }
    },
    actions: {
        async getMessages({ commit }){
            return await MessageAPI.getMessages()
              .then(res => {
                commit("setMessages", res.data)
                return res.status;
              })
              .catch((error) => {
                let errorStatus = error.response.status

                if (String(errorStatus).startsWith('4')){
                  commit('clientError', null, { root: true })
                }else if(String(errorStatus).startsWith('5')){
                  commit('serverError', null, { root: true })
                }
                
                return errorStatus;
              });
        },
        async deleteMessage({ state }) {
            return await MessageAPI.deleteMessage(state.messageId)
              .then(() => "success")
              .catch((error) => {
                let errorStatus = error.response.status

                if (String(errorStatus).startsWith('4')){
                  commit('clientError', null, { root: true })
                }else if(String(errorStatus).startsWith('5')){
                  commit('serverError', null, { root: true })
                }
                
                return errorStatus;
              });
        },
        async changeStatusMessage({ state }, statusData) {
            return await MessageAPI.changeStatusMessage(state.messageId, statusData)
              .then(() => "success")
              .catch((error) => {
                let errorStatus = error.response.status

                if (String(errorStatus).startsWith('4')){
                  commit('clientError', null, { root: true })
                }else if(String(errorStatus).startsWith('5')){
                  commit('serverError', null, { root: true })
                }
                
                return errorStatus;
              });
        }
    },
    namespaced: true
}